import { isValidPhoneNumber } from 'libphonenumber-js';

/**
 * Validates if a phone number is a valid US phone number.
 * Supports various formats: 6143577539, (614) 357-7539, +1 614 357 7539, etc
 * 
 * @param {string} phoneNumber - The phone number to validate
 * @returns {boolean} - true if valid US number, false otherwise
 */
export const isValidUSPhone = (phoneNumber) => {
    if (!phoneNumber) return false;

    // Validates against US numbering plan rules
    try {
        return isValidPhoneNumber(phoneNumber, 'US');
    } catch (error) {
        return false;
    }
};
